import _ from "lodash";
import { AccountingEntity } from "../../entity/AccountingEntity";
import { TrialsEntity } from "../../entity/TrialsEntity";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

export class Accounting {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.accounting}/accounting`;

    constructor() {}

    async downgrade({ accountingId, contract, downgrade }) {
        if (!accountingId || !contract || !downgrade)
            throw new Error(
                `Missing params: accountingId || exemptiom || downgrade`
            );
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/downgrade`,
            {
                _id: accountingId,
                contract,
                downgrade
            }
        );
        return response;
    }

    async churn({ accountingId, churn }) {
        if (!accountingId || !churn)
            throw new Error(`Missing params: accountingId || churn`);
        const response = await this.HttpAdapter.call(`${this.baseUrl}/churn`, {
            _id: accountingId,
            churn
        });
        return response;
    }

    async grow({ accountingId, contract, grow }) {
        if (!accountingId || !contract || !grow)
            throw new Error(`Missing params: accountingId || contract || grow`);
        const response = await this.HttpAdapter.call(`${this.baseUrl}/grow`, {
            _id: accountingId,
            contract,
            grow
        });
        return response;
    }

    async getSuperlogicaToken({ accountingId } = {}) {
        if (!accountingId) return false;

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-superlogica-token`,
            {
                accountingId
            }
        );

        return response;
    }

    async deactivateSubscription({
        user: { name, email },
        motivation: { summary, description },
        accountingId
    } = {}) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-subscriptions`,
            {
                user: { name, email },
                status: "deactivate",
                motivation: { summary, description },
                accountingId
            }
        );

        return response;
    }

    async activateSubscription({ user: { name, email }, accountingId } = {}) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-subscriptions`,
            {
                user: { name, email },
                status: "activate",
                accountingId
            }
        );

        return response;
    }

    async integrateSerpro({
        accountingId,
        signedAuthorizationTermXMLString,
        validityDate,
        socialName,
        document
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/integration/set-serpro-integration`,
            {
                accountingId,
                signedAuthorizationTermXMLString,
                validityDate,
                socialName,
                document
            }
        );

        return response;
    }

    async updateAnalysisPlus({ accountingId, company }) {
        if (!accountingId || !company) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/update-analysis-plus`,
                {
                    accountingId,
                    company: {
                        _id: company._id,
                        name: company.name,
                        status: company.status
                    }
                }
            );
            return response;
        } catch (error) {
            console.log("err", error);
            return error;
        }
    }

    async updatePreferenceDominio({ accountingId, dominioView } = {}) {
        if (!accountingId) return false;

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-many`,
            {
                accountings: [
                    {
                        _id: accountingId,
                        dominioView
                    }
                ]
            }
        );

        return response;
    }

    async updateIntegrationPreference({
        accountingId,
        integrationsPreference
    } = {}) {
        if (!accountingId) return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-many`,
            {
                accountings: [
                    {
                        _id: accountingId,
                        integrationsPreference
                    }
                ]
            }
        );

        return response;
    }

    async updateMany({ accountings } = {}) {
        if (!accountings?.length) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/update-many`,
                {
                    accountings
                }
            );
            return response;
        } catch (error) {
            throw new Error(
                error?.message || "Erro ao atualizar contabilidades"
            );
        }
    }

    async updateMySystems({ accountingId, mySystems } = {}) {
        if (!accountingId || !mySystems) return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-many`,
            {
                accountings: [
                    {
                        _id: accountingId,
                        mySystems
                    }
                ]
            }
        );
        return response;
    }

    async updateMySystemsAndOnboarding({
        accountingId,
        mySystems,
        onboarding
    } = {}) {
        if (!accountingId || !mySystems || !onboarding) return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-many`,
            {
                accountings: [
                    {
                        _id: accountingId,
                        mySystems,
                        onboarding
                    }
                ]
            }
        );
        return response;
    }

    async updateOnboarding({ accountingId, onboarding } = {}) {
        if (!accountingId || !onboarding) return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/update-many`,
            {
                accountings: [
                    {
                        _id: accountingId,
                        onboarding
                    }
                ]
            }
        );

        return response;
    }

    async requestProductGrowth({
        accountingId,
        pckge,
        licenses,
        email,
        options
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/request-product-growth`,
            {
                accountingId,
                package: pckge,
                licenses,
                email,
                options
            }
        );
        return response;
    }

    async getById(_id) {
        if (!_id) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-by-id`,
                {
                    _id
                }
            );
            return response;
        } catch (err) {
            return null;
        }
    }

    async requestProductGrowth({
        accountingId,
        pckge,
        licenses,
        email,
        options
    }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/request-product-growth`,
                {
                    accountingId,
                    package: pckge,
                    licenses,
                    email,
                    options
                }
            );
            return response;
        } catch (error) {
            return false;
        }
    }

    async ticketExemptiom({ accountingId, exemption }) {
        if (!accountingId || !exemption) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/exemption`,
                {
                    _id: accountingId,
                    exemption
                }
            );
            return response;
        } catch (error) {
            return false;
        }
    }

    async changeStatus({ _id, status }) {
        if (!_id || !status) throw new Error(`Missing params: _id || status`);
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/change-status`,
                {
                    _id,
                    status
                }
            );
            return response;
        } catch (error) {
            return false;
        }
    }

    async remove(_id) {
        if (!_id) throw new Error(`Missing params: _id`);
        const userId = new UserDataAdapter().user()._id;
        if (!userId) throw new Error(`Missing params: userId`);
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/remove`,
                {
                    _id,
                    userId
                }
            );
            return response;
        } catch (error) {
            return false;
        }
    }

    async getTrials({ page, sort, filter, searchText, limit }) {
        if (!limit) limit = 30;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-trialls`,
            {
                searchText,
                limit,
                page,
                sort,
                filter
            }
        );
        const accountingsTriallEntity = response.list.map((triall) => {
            const accountingsTriall = new TrialsEntity(triall);
            accountingsTriall.fomratedOrigin();
            accountingsTriall.createdAtDateString();
            accountingsTriall.expiredAtAtDateString();
            accountingsTriall.statusTrialView();
            accountingsTriall.formatTotalFees();
            accountingsTriall.formatTicketMedium();
            accountingsTriall.changeColorScore();
            accountingsTriall.elapsedCompanies();
            accountingsTriall.elapsedAccess();
            return accountingsTriall;
        });
        return { total: response.total, accountingsTriallEntity };
    }

    async saveAccounting(body) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/save`,
            body
        );
        return response;
    }

    async recissionRequest(data) {
        const input = {
            accountingId: data.accountingId,
            userId: data.userId,
            ...(data.reverse ? { reverse: data.reverse } : {}),
            ...(_.size(data.details) ? { details: data.details } : {})
        };
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/rescission-request`,
            input
        );
        return response;
    }

    async getCustomers({ page, sort, filter, searchText, limit }) {
        if (!limit) limit = 30;
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/get-customers`,
            {
                searchText,
                limit,
                page,
                sort,
                filter
            }
        );
        const accountingsEntity = response.list.map((accounting) => {
            const accountingEntity = new AccountingEntity(
                accounting,
                accounting._id
            );
            accountingEntity.formatTotalFees();
            accountingEntity.formatTicketMedium();
            accountingEntity.changeColorScore();
            accountingEntity.abbreviationCS();
            accountingEntity.statusSuperlogicaView();
            accountingEntity.elapsedDateCompanies();
            accountingEntity.elapsedAccess();
            accountingEntity.elapsedInput();
            accountingEntity.elapsedReport();
            accountingEntity.createdAtClient();
            accountingEntity.setLevelMission();
            return accountingEntity;
        });
        return {
            accountingsEntity,
            total: response.total
        };
    }
}
